module.exports = __webpack_public_path__ + "static/img/ad5.f8444b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad5.png
// module id = qIrj
// module chunks = 12